module.exports = __webpack_public_path__ + "img/forgot_pass_mobile.6c6cdb17.png";